<template>
  <div>
    <!-- <md-field class="align-items-center">
      <label>Discount Code</label>
      <md-input
        v-model="discountCode"
        type="text"
        @input="val => (discountCode = discountCode.toUpperCase())"
      />
      <md-icon>local_offer</md-icon>
    </md-field> -->
    <div class="summaryWell">
      <md-table>
        <md-table-row>
          <md-table-head><h5>Order Summary</h5></md-table-head>
        </md-table-row>
        <md-table-row>
          <md-table-cell>{{ cart.length }} access pass</md-table-cell>
          <md-table-cell md-numeric
            >${{ centsToDollars(itemTotal) }}</md-table-cell
          >
        </md-table-row>
        <md-table-row v-if="discountTotal">
          <md-table-cell>Discount</md-table-cell>
          <md-table-cell md-numeric
            >${{ centsToDollars(discountTotal) }}</md-table-cell
          >
        </md-table-row>
        <md-table-row v-if="deliveryTotal">
          <md-table-cell>Delivery</md-table-cell>
          <md-table-cell md-numeric
            >${{ centsToDollars(deliveryTotal) }}</md-table-cell
          >
        </md-table-row>
        <md-table-row>
          <md-table-cell><h5 class="mb-0">Total</h5></md-table-cell>
          <md-table-cell md-numeric
            ><h5 class="mb-0">
              ${{ centsToDollars(grandTotal) }}
            </h5></md-table-cell
          >
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { centsToDollars } from "@/util";

export default {
  name: "OrderSummaryTable",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      deliveryTotal: null,
      discountCode: "",
      showText: true
    };
  },
  computed: {
    itemTotal: function() {
      return this.cartTotal;
    },
    grandTotal: function() {
      return this.itemTotal + this.discountTotal + this.deliveryTotal;
    },
    discountTotal() {
      let codes = {
        "20OFF": -20,
        "10OFF": -10
      };
      let sale =
        codes[this.discountCode] != undefined ? codes[this.discountCode] : 0;
      return this.itemTotal * (sale / 100);
    },
    ...mapGetters(["cart", "cartTotal"])
  },
  methods: {
    centsToDollars: centsToDollars
  }
};
</script>
<style lang="scss"></style>
